module.exports = __webpack_public_path__ + "static/accor-hotels.75cc49e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/accor-hotels.svg
// module id = 414
// module chunks = 59819425949494